import axios from './requestClient';

export async function fetchUsers(params) {
  return axios.get('/api/v1/User', {
    params,
  });
}

export async function fetchUserDetails(id) {
  return axios.get(`/api/v1/User/${id}`);
}

export async function postUser(data) {
  return axios.post('/api/v1/User', data);
}

export async function putUser(id, data) {
  return axios.put(`/api/v1/User/${id}`, data);
}

export async function deleteUser(id, data) {
  return axios.delete(`/api/v1/User/${id}`, {
    params: data,
  });
}

export async function fetchUserRoles(id) {
  return axios.get(`/api/v1/User/${id}/Roles`);
}

export async function fetchUserCustomerGroups(id) {
  return axios.get(`/api/v1/User/${id}/Groups`);
}

export async function postUserRoles(id, data) {
  return axios.post(`/api/v1/User/${id}/Roles`, data);
}

export async function deleteUserRole(id, data) {
  return axios.delete(`/api/v1/User/${id}/Roles`, { data });
}

export async function postResendVerifyEmail(id) {
  return axios.post(`/api/v1/User/${id}/ResendEmailVerification`);
}
